export default "__VITE_ASSET__CQHj07co__"